<button mat-icon-button mat-dialog-close
    class="absolute right-2 top-2 z-10 opacity-50 transition-opacity hover:opacity-100 scale-75" (click)="close()">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
    </svg>
    <span class="sr-only">Close</span>
</button>

<div class="px-6 py-6 min-w-[50vw]">
    <div class="mb-6 flex flex-col space-y-1">
        <h2 mat-dialog-title class="!m-0 text-lg font-semibold leading-none tracking-tight">
            {{category.id ? category.name : 'Criar Nova Categoria'}}
        </h2>
        <p class="text-muted-foreground text-sm leading-relaxed" *ngIf="category.id == null">
            Adicione uma nova categoria ao marketplace. Subcategorias podem ser
            adicionadas separadas por vírgula.
        </p>
    </div>

    <form class="grid" [formGroup]="form">
        <mat-dialog-content class="!m-0 overflow-visible !p-0">
            <div class="space-y-4">
                <div class="space-y-2">
                    <label class="text-sm font-medium leading-none" for="nome">Nome da Categoria</label>
                    <input
                        class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="nome" placeholder="Ex: Instrumentos Musicais" formControlName="name" />
                    @if (form?.get('name')?.invalid && form?.get('name')?.touched) {
                    <mat-error class="text-xs text-red-500 italic">Campo obrigatório</mat-error>
                    }
                </div>

                <div class="space-y-2">
                    <label class="text-sm font-medium leading-none" for="descricao">Descrição</label>
                    <textarea
                        class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="descricao" placeholder="Descrição breve da categoria..." formControlName="slug"></textarea>
                    @if (form?.get('slug')?.invalid && form?.get('slug')?.touched) {
                    <mat-error class="text-xs text-red-500 italic">Campo obrigatório</mat-error>
                    }
                </div>

                <div class="space-y-2">
                    <label class="text-sm font-medium leading-none" for="subcategorias">Subcategorias</label>
                    <input
                        class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="subcategorias" placeholder="Violão, Guitarra, Bateria..." formControlName="subcategory" />
                    <p class="text-muted-foreground text-[11px] italic">
                        Separe as subcategorias por vírgula
                    </p>
                </div>

                <div class="space-y-2">
                    <label class="text-sm font-medium leading-none" for="icone">Ícone da Categoria</label>
                    <mat-form-field appearance="outline" class="w-full fuse-mat-dense h-12" subscriptSizing="dynamic">
                        <ng-icon matPrefix [name]="form.get('icon')?.value" *ngIf="form.get('icon')?.value" class="text-xl ml-2 mr-2"></ng-icon>
                        <input type="text" placeholder="Pesquisar ícone..." matInput formControlName="icon" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let icon of filteredIcons" [value]="icon">
                                <span class="flex items-center gap-2">
                                    <ng-icon [name]="icon" class="text-xl"></ng-icon>
                                    <span>{{ icon.replace('phosphor', '') }}</span>
                                </span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="space-y-2">
                    <label class="text-sm font-medium leading-none" for="ordem">Ordem de Exibição</label>
                    <input
                        type="number"
                        class="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="ordem" placeholder="Ex: 1 (Menor número = maior prioridade)" formControlName="priority_order" />
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions *ngIf="!permissionService.can('create_category') || !permissionService.can('edit_category')"
            class="mt-8 !flex flex-col-reverse border-none !p-0 sm:flex-row sm:justify-end sm:space-x-2">
            <button mat-dialog-close
                class="hidden sm:flex gap-2 rounded-md border-input" (click)="close()">
                Cancelar
            </button>
            <button
                class="text-white inline-flex h-10 w-full items-center justify-center rounded-md bg-[#eb670f] px-6 py-2 text-sm font-medium transition-colors hover:bg-[#d55b0a] sm:w-auto"
                (click)="save()">
                Criar Categoria
            </button>
        </mat-dialog-actions>
    </form>
</div>